// extracted by mini-css-extract-plugin
export default {"playersInputs":"PlayersInputs_playersInputs__26JHT"};